// ref: https://github.com/vercel/ai/blob/42690fe287a22a2464a9f5b473b5ffd0695b4431/packages/ai/core/middleware/extract-reasoning-middleware.ts#L13
// (we do this on the frontend because the messages are encrypted)
const MEMORY_TAG_NAME = 'memory';
const MEMORY_OPENING_TAG = `<${MEMORY_TAG_NAME}>`;
const MEMORY_CLOSING_TAG = `<\/${MEMORY_TAG_NAME}>`;
const MEMORY_REGEXP = new RegExp(
  `${MEMORY_OPENING_TAG}(.*?)${MEMORY_CLOSING_TAG}`,
  'gs'
);

export function stripMemoryTags(content: string): string {
  return content.replace(MEMORY_REGEXP, '');
}
